export const extractBrandName = (url: string) => {
  return /(https?:\/\/)?(www\.)?(.+)(\..+)(\/)?/.exec(url)?.[3]
}
